window.IB_DISABLE_CART_LOGIC = false;

/* =========================
   Config
========================= */

/*
  Cart mode options:
  - 'drawer' = add-to-cart opens/refetches cart drawer
  - 'page'   = add-to-cart redirects to full cart page
*/
const IB_CART_MODE = 'page';

const IB_CART_CONTAINER_SELECTOR =
  IB_CART_MODE === 'drawer'
    ? '#cart-drawer'
    : 'cart-items, .cart-items, form[action="/cart"], form[action*="/cart"], main';

const IB_BASE_TEST_VARIANT_IDS = ['49323903385868'];

const IB_ADDON_TYPES = {
  nutrition: 'nutrition',
  recipe: 'recipe'
};

let ibProductFormSubmitting = false;
let ibCartLineChanging = false;
let ibReinitTimer = null;
let ibProductObserverStarted = false;

/* =========================
   Boot
========================= */

function initIbProductPageFeatures() {
  initIbAddonSelector();
  initIbAddonCollapse();
  initIbDynamicPricing();
  initIbProductForm();
  initIbProductObserver();
}

document.addEventListener('DOMContentLoaded', () => {
  initIbProductPageFeatures();
  initIbCartSync();
});

// Shopify can replace product sections after first paint / editor reload / variant rendering.
document.addEventListener('shopify:section:load', () => {
  initIbProductPageFeatures();
});

// Back/forward cache support.
window.addEventListener('pageshow', () => {
  initIbProductPageFeatures();
});

/* =========================
   Helpers
========================= */

function ibIsCartDrawerMode() {
  return IB_CART_MODE === 'drawer';
}

function ibIsCartPageMode() {
  return IB_CART_MODE === 'page';
}

function ibGetCartContainerFromEvent(event) {
  return event.target.closest(IB_CART_CONTAINER_SELECTOR);
}

function ibCartHasBundleRows() {
  return !!document.querySelector(
    '.js-cart-item[data-ib-bundle-id]:not([data-ib-bundle-id=""])[data-ib-bundle-role]:not([data-ib-bundle-role=""])'
  );
}

function ibWait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function ibTrack(eventName, properties = {}) {
  if (window.posthog && typeof window.posthog.capture === 'function') {
    window.posthog.capture(eventName, properties);
  }
}

function ibGenerateBundleId() {
  if (window.crypto && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  return 'ib-' + Date.now() + '-' + Math.random().toString(36).slice(2);
}

function formatIbMoney(cents) {
  return '€' + (cents / 100).toFixed(2).replace('.', ',');
}

function ibCartPath(path) {
  const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  return root.replace(/\/$/, '') + path;
}

async function ibFetchCart() {
  const response = await fetch(ibCartPath('/cart.js'), {
    headers: { Accept: 'application/json' }
  });

  return response.json();
}

async function ibChangeLine(key, quantity) {
  return fetch(ibCartPath('/cart/change.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      id: key,
      quantity
    })
  });
}

async function ibAddItems(items) {
  return fetch(ibCartPath('/cart/add.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ items })
  });
}

function ibSetCartLoading(active) {
  const cartRoot = ibIsCartDrawerMode()
    ? document.querySelector('#cart-drawer')
    : document.querySelector('cart-items, .cart-items, form[action="/cart"], form[action*="/cart"], main');

  if (!cartRoot) return;

  cartRoot.classList.toggle('ib-cart-loading', active);
}

async function ibUpdateLines(updates) {
  return fetch(ibCartPath('/cart/update.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({ updates })
  });
}

function ibIsBaseRow(row) {
  return row &&
    row.dataset.ibBundleId &&
    row.dataset.ibBundleId.trim() !== '' &&
    row.dataset.ibBundleRole === 'base';
}

function ibIsAddonRow(row) {
  return row &&
    row.dataset.ibBundleId &&
    row.dataset.ibBundleId.trim() !== '' &&
    row.dataset.ibBundleRole === 'addon';
}

function ibIsBundleRow(row) {
  return row &&
    row.dataset.ibBundleId &&
    row.dataset.ibBundleId.trim() !== '' &&
    (
      row.dataset.ibBundleRole === 'base' ||
      row.dataset.ibBundleRole === 'addon'
    );
}

async function ibGetCartItemByKey(lineKey) {
  const cart = await ibFetchCart();

  return {
    cart,
    item: cart.items.find(item => item.key === lineKey)
  };
}

function ibGetBundleItems(cart, bundleId) {
  return cart.items.filter(item =>
    item.properties &&
    item.properties._ib_bundle_id === bundleId
  );
}

function ibIsMembershipRow(row) {
  return row && row.dataset.ibLineType === 'membership';
}

function ibSafeCssEscape(value) {
  if (window.CSS && typeof CSS.escape === 'function') {
    return CSS.escape(value);
  }

  return String(value).replace(/"/g, '\\"');
}

function ibGetProductForms() {
  return [
    ...document.querySelectorAll(
      'form[action*="/cart/add"], product-form form, form[data-type="add-to-cart-form"]'
    )
  ];
}

function ibIsRelevantBundleProductPage() {
  return !!document.querySelector('[data-ib-addons]');
}

function ibGetFormVariantId(form) {
  const input = form ? form.querySelector('[name="id"]') : null;
  return input ? String(input.value || '') : '';
}

function ibGetCartErrorElement(form) {
  return (
    form?.querySelector('[data-ib-cart-error]') ||
    document.querySelector('[data-ib-cart-error]') ||
    null
  );
}

function ibShowCartError(form, message) {
  const errorEl = ibGetCartErrorElement(form);

  if (!errorEl) return;

  errorEl.textContent = message;
  errorEl.removeAttribute('hidden');
  errorEl.classList.add('is-visible');
}

function ibClearCartError(form) {
  const errorEl = ibGetCartErrorElement(form);

  if (!errorEl) return;

  errorEl.textContent = '';
  errorEl.setAttribute('hidden', '');
  errorEl.classList.remove('is-visible');
}

function ibSetSubmitLoading(submitButton, active) {
  if (!submitButton) return;

  submitButton.disabled = active;
  submitButton.classList.toggle('loading', active);
  submitButton.setAttribute('aria-busy', active ? 'true' : 'false');
}

async function ibClearCart() {
  const response = await fetch(ibCartPath('/cart/clear.js'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Could not clear cart');
  }

  return response.json();
}

/* =========================
   Re-init observer
========================= */

function initIbProductObserver() {
  if (ibProductObserverStarted) return;
  if (!document.body) return;

  ibProductObserverStarted = true;

  const productRoot =
    document.querySelector('main') ||
    document.querySelector('.product') ||
    document.body;

  const observer = new MutationObserver(mutations => {
    const hasRelevantChange = mutations.some(mutation => {
      return [...mutation.addedNodes, ...mutation.removedNodes].some(node => {
        if (!(node instanceof HTMLElement)) return false;

        return (
          node.matches?.('[data-ib-addons], [data-addon-toggle], [data-addon-collapsible], form[action*="/cart/add"], product-form') ||
          node.querySelector?.('[data-ib-addons], [data-addon-toggle], [data-addon-collapsible], form[action*="/cart/add"], product-form')
        );
      });
    });

    if (!hasRelevantChange) return;

    clearTimeout(ibReinitTimer);

    ibReinitTimer = setTimeout(() => {
      initIbProductPageFeatures();
    }, 100);
  });

  observer.observe(productRoot, {
    childList: true,
    subtree: true
  });
}

/* =========================
   Product page addon selector
========================= */

function initIbAddonSelector() {
  const bundleToggle = document.querySelector('[data-ib-bundle-toggle]');
  const bundleBox = document.querySelector('[data-ib-bundle-option]');

  if (!bundleToggle || !bundleBox) return;

  updateIbAddonInitialState();

  if (document.documentElement.dataset.ibAddonSelectorDelegated === 'true') {
    return;
  }

  document.documentElement.dataset.ibAddonSelectorDelegated = 'true';

  document.addEventListener('change', event => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement)) return;

    if (!input.matches('[data-ib-bundle-toggle], [data-addon-variant-id]')) {
      return;
    }

    if (input.matches('[data-ib-bundle-toggle]')) {
      ibSetBundleState(input.checked);

      ibTrack('IB Bundle Toggle Changed', {
        checked: input.checked
      });
    }

    if (input.matches('[data-addon-variant-id]')) {
      if (input.checked && input.dataset.bundleMember === 'true') {
        ibSetBundleState(false);
      }

      if (input.checked && input.dataset.addonType === IB_ADDON_TYPES.recipe) {
        const nutritionInput = document.querySelector('[data-addon-type="nutrition"]');

        if (nutritionInput) {
          nutritionInput.checked = true;
        }
      }

      ibUpdateRecipeDependencyState();

      ibTrack('IB Addon Option Changed', {
        addonType: input.dataset.addonType || null,
        addonVariantId: input.dataset.addonVariantId || null,
        checked: input.checked
      });
    }

    updateIbDynamicPricing();
  });
}

function updateIbAddonInitialState() {
  const bundleToggle = document.querySelector('[data-ib-bundle-toggle]');

  if (bundleToggle) {
    ibSetBundleState(bundleToggle.checked);
  }

  ibUpdateRecipeDependencyState();
  updateIbDynamicPricing();
}

function ibUpdateRecipeDependencyState() {
  const recipeInput = document.querySelector('[data-addon-type="recipe"]');
  const nutritionInput = document.querySelector('[data-addon-type="nutrition"]');

  if (!recipeInput || !nutritionInput) return;

  const nutritionWrapper =
    nutritionInput.closest('label') ||
    nutritionInput.closest('.ib-addon-option') ||
    nutritionInput.closest('[data-bundle-dependent]');

  if (recipeInput.checked) {
    nutritionInput.checked = true;
    nutritionInput.disabled = true;

    if (nutritionWrapper) {
      nutritionWrapper.classList.add('is-disabled-by-recipe');
    }
  } else {
    nutritionInput.disabled = false;

    if (nutritionWrapper) {
      nutritionWrapper.classList.remove('is-disabled-by-recipe');
    }
  }
}

function ibUpdateBundleDependentState(active) {
  const bundleDependentItems = [...document.querySelectorAll('[data-bundle-dependent]')];

  bundleDependentItems.forEach(item => {
    const input = item.querySelector('input');

    item.classList.toggle('is-disabled-by-bundle', active);

    if (input) {
      input.disabled = active;

      if (active) {
        input.checked = false;
      }
    }
  });

  ibUpdateRecipeDependencyState();
}

function ibSetBundleState(active) {
  const bundleToggle = document.querySelector('[data-ib-bundle-toggle]');
  const bundleBox = document.querySelector('[data-ib-bundle-option]');

  if (!bundleToggle || !bundleBox) return;

  bundleToggle.checked = active;
  bundleBox.classList.toggle('is-selected', active);
  bundleBox.setAttribute('aria-pressed', active ? 'true' : 'false');

  ibUpdateBundleDependentState(active);
}

function initIbAddonCollapse() {
  document.querySelectorAll('[data-addon-toggle]').forEach(toggle => {
    toggle.removeAttribute('data-loading');
    toggle.setAttribute('aria-expanded', toggle.classList.contains('is-open') ? 'true' : 'false');

    // Prevent accidental form submit when the toggle is a button without type.
    if (toggle.tagName === 'BUTTON' && !toggle.getAttribute('type')) {
      toggle.setAttribute('type', 'button');
    }
  });

  if (document.documentElement.dataset.ibAddonCollapseDelegated === 'true') {
    return;
  }

  document.documentElement.dataset.ibAddonCollapseDelegated = 'true';

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-addon-toggle]');
    if (!toggle) return;

    event.preventDefault();

    const wrapper =
      toggle.closest('[data-ib-addons]') ||
      toggle.closest('.ib-addon-box') ||
      document;

    const content = wrapper.querySelector('[data-addon-collapsible]');
    if (!content) return;

    const isOpen = content.classList.toggle('is-open');

    toggle.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    ibTrack('IB Addon Accordion Clicked', {
      isOpen
    });
  });
}

/* =========================
   Dynamic pricing
========================= */

function calculateIbTotal() {
  const addonBox = document.querySelector('[data-ib-addons]');
  const bundleToggle = document.querySelector('[data-ib-bundle-toggle]');

  if (!addonBox) return 0;

  const basePrice = Number(addonBox.dataset.basePrice || 0);
  const bundleActive = bundleToggle && bundleToggle.checked;

  let total = basePrice;

  if (bundleActive) {
    total += 6900;
  }

  // Bundle prices need to be updated in ib-product-addons.liquid and product-sticky-quick-add.liquid as well.
  document.querySelectorAll('[data-addon-variant-id]:checked').forEach(input => {
    const isBundleMember = input.dataset.bundleMember === 'true';

    if (bundleActive && isBundleMember) return;

    total += Number(input.dataset.addonPrice || 0);
  });

  return total;
}

function updateIbDynamicPricing() {
  const totalEl = document.querySelector('[data-ib-total-price]');
  const atc = document.querySelector('[data-ib-atc]');
  const total = calculateIbTotal();

  if (totalEl) {
    totalEl.textContent = formatIbMoney(total);
  }

  if (atc) {
    atc.textContent = `Get your test — ${formatIbMoney(total)}`;
  }
}

function initIbDynamicPricing() {
  updateIbDynamicPricing();
}

function getIbSelectedAddonVariantIds() {
  const bundleToggle = document.querySelector('[data-ib-bundle-toggle]');
  const bundleActive = bundleToggle && bundleToggle.checked;

  let selectedVariantIds = [];

  if (bundleActive) {
    selectedVariantIds = [...document.querySelectorAll('[data-bundle-member="true"]')]
      .map(input => input.dataset.addonVariantId)
      .filter(Boolean);
  }

  const checkedInputs = [...document.querySelectorAll('[data-addon-variant-id]:checked')];

  const individuallySelectedVariantIds = checkedInputs
    .filter(input => {
      const isBundleMember = input.dataset.bundleMember === 'true';
      return !(bundleActive && isBundleMember);
    })
    .map(input => input.dataset.addonVariantId)
    .filter(Boolean);

  selectedVariantIds = [...selectedVariantIds, ...individuallySelectedVariantIds];

  const recipeSelected = checkedInputs.some(input => {
    return input.dataset.addonType === IB_ADDON_TYPES.recipe;
  });

  if (recipeSelected && !bundleActive) {
    const nutritionInput = document.querySelector('[data-addon-type="nutrition"]');

    if (nutritionInput && nutritionInput.dataset.addonVariantId) {
      selectedVariantIds.push(nutritionInput.dataset.addonVariantId);
    }
  }

  return [...new Set(selectedVariantIds)];
}

/* =========================
   Subscription selector tracking / resilience
========================= */

function initIbSubscriptionTracking() {
  if (document.documentElement.dataset.ibSubscriptionTrackingDelegated === 'true') {
    return;
  }

  document.documentElement.dataset.ibSubscriptionTrackingDelegated = 'true';

  document.addEventListener('change', event => {
    const input = event.target;

    if (!(input instanceof HTMLInputElement || input instanceof HTMLSelectElement)) return;

    const isSubscriptionControl =
      input.matches('[name="selling_plan"]') ||
      input.closest('[data-selling-plan]') ||
      input.closest('.selling-plan') ||
      input.closest('.subscription') ||
      input.closest('[data-subscription]');

    if (!isSubscriptionControl) return;

    ibTrack('IB Subscription Option Changed', {
      name: input.name || null,
      value: input.value || null,
      checked: 'checked' in input ? input.checked : null
    });
  });
}

/* =========================
   Product add-to-cart
========================= */

async function ibRemoveExistingIbBundleForVariant(baseVariantId) {
  const cart = await ibFetchCart();

  const existingBases = cart.items.filter(item => {
    return (
      String(item.variant_id) === String(baseVariantId) &&
      item.properties &&
      item.properties._ib_bundle_role === 'base'
    );
  });

  const keysToRemove = [];

  existingBases.forEach(base => {
    const bundleId = base.properties._ib_bundle_id;

    cart.items.forEach(item => {
      if (item.properties && item.properties._ib_bundle_id === bundleId) {
        keysToRemove.push(item.key);
      }
    });
  });

  if (!keysToRemove.length) return;

  await Promise.all(keysToRemove.map(key => ibChangeLine(key, 0)));
}

function initIbProductForm() {
  if (window.IB_DISABLE_CART_LOGIC) {
    console.log('[IB] Product form logic disabled');
    return;
  }

  initIbSubscriptionTracking();

  if (!ibIsRelevantBundleProductPage()) return;

  const forms = ibGetProductForms();
  if (!forms.length) return;

  forms.forEach(form => {
    if (form.dataset.ibProductFormInitialized === 'true') return;
    form.dataset.ibProductFormInitialized = 'true';

    form.addEventListener(
      'submit',
      async event => {
        const formData = new FormData(form);
        const baseVariantId = String(formData.get('id') || '');

        // Only hijack the known InnerBuddies base-test variant.
        // Other products/subscription widgets stay fully controlled by theme/app logic.
        if (!IB_BASE_TEST_VARIANT_IDS.includes(baseVariantId)) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        if (ibProductFormSubmitting) {
          ibTrack('IB Product Add Submit Blocked Duplicate', {
            baseVariantId
          });
          return;
        }

        ibProductFormSubmitting = true;
        ibClearCartError(form);

        const submitButton =
          form.querySelector('[type="submit"]') ||
          document.querySelector('[data-ib-atc]');

        ibSetSubmitLoading(submitButton, true);

        const quantity = Math.max(1, Number(formData.get('quantity') || 1));
        const sellingPlan = formData.get('selling_plan');
        const bundleId = ibGenerateBundleId();

        const stickyBundleVariantIds = [...form.querySelectorAll('[data-ib-sticky-bundle-member]')]
          .map(input => input.value)
          .filter(Boolean);

        const selectedAddonVariantIds = stickyBundleVariantIds.length
          ? stickyBundleVariantIds
          : getIbSelectedAddonVariantIds();

        const baseItem = {
          id: Number(baseVariantId),
          quantity,
          properties: {
            _ib_bundle_id: bundleId,
            _ib_bundle_role: 'base'
          }
        };

        // Critical for subscription interval selectors / selling-plan apps.
        if (sellingPlan) {
          baseItem.selling_plan = Number(sellingPlan);
        }

        const items = [
          baseItem,
          ...selectedAddonVariantIds.map(variantId => ({
            id: Number(variantId),
            quantity,
            properties: {
              _ib_bundle_id: bundleId,
              _ib_bundle_role: 'addon',
              _ib_parent_variant_id: String(baseVariantId)
            }
          }))
        ];

        ibTrack('IB Product Add Submit Started', {
          baseVariantId,
          selectedAddonCount: selectedAddonVariantIds.length,
          quantity,
          hasSellingPlan: !!sellingPlan,
          cartMode: IB_CART_MODE
        });

        try {
          // Checkout flow moet altijd beginnen met een lege cart
          await ibClearCart();

          const response = await ibAddItems(items);

          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Add to cart failed: ${errorText}`);
          }

          ibTrack('IB Product Added', {
            baseVariantId,
            selectedAddonCount: selectedAddonVariantIds.length,
            quantity,
            hasSellingPlan: !!sellingPlan,
            cartMode: IB_CART_MODE
          });

          document.dispatchEvent(new CustomEvent('ib:product-added', {
            detail: {
              baseVariantId,
              selectedAddonVariantIds,
              quantity,
              sellingPlan: sellingPlan || null,
              cartMode: IB_CART_MODE
            }
          }));

          if (ibIsCartPageMode()) {
            // move directly to checkout page
            // window.location.href = ibCartPath('/cart');
            // move directly to checkout page
            window.location.href = ibCartPath('/checkout');
            return;
          }

          await ibRefreshAfterCartChange();
          ibOpenCartDrawerInstant();
        } catch (error) {
          console.error('[IB] Add to cart failed:', error);

          ibShowCartError(form, 'Something went wrong. Please try again.');

          ibTrack('IB Product Add Failed', {
            baseVariantId,
            selectedAddonCount: selectedAddonVariantIds.length,
            quantity,
            hasSellingPlan: !!sellingPlan,
            cartMode: IB_CART_MODE,
            error: String(error.message || error)
          });
        } finally {
          ibSetSubmitLoading(submitButton, false);

          setTimeout(() => {
            ibProductFormSubmitting = false;
          }, 300);
        }
      },
      true
    );
  });
}

/* =========================
   Cart drawer refresh/open
========================= */

function ibOpenCartDrawerInstant() {
  if (!ibIsCartDrawerMode()) return;

  const drawer = document.querySelector('#cart-drawer');

  if (drawer) {
    drawer.removeAttribute('hidden');
    drawer.setAttribute('open', 'true');
    drawer.classList.add('menu-opening', 'open', 'is-open', 'active');
    document.body.classList.add('overflow-hidden');
  }

  const openButton =
    document.querySelector('[data-drawer-to-open="cart-drawer"]') ||
    document.querySelector('[aria-controls="cart-drawer"]');

  if (openButton && !drawer?.hasAttribute('open')) {
    openButton.click();
  }
}

async function ibRefreshCartDrawer() {
  if (!ibIsCartDrawerMode()) {
    return false;
  }

  if (window.IB_DISABLE_CART_LOGIC) {
    console.log('[IB] Refresh disabled');
    return false;
  }

  const currentSection =
    document.querySelector('[id$="__cart-drawer"]') ||
    document.querySelector('#cart-drawer')?.closest('.shopify-section');

  const currentDrawer = document.querySelector('#cart-drawer');

  if (!currentSection || !currentDrawer) {
    console.warn('[IB] Current cart drawer/section not found');
    return false;
  }

  const sectionId = currentSection.id.replace('shopify-section-', '');

  const urls = [
    `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&_=${Date.now()}`,
    `${window.location.pathname}?sections=${encodeURIComponent(sectionId)}&_=${Date.now()}`,
    `${ibCartPath('/cart')}?section_id=${encodeURIComponent(sectionId)}&_=${Date.now()}`
  ];

  for (const url of urls) {
    try {
      const response = await fetch(url, {
        headers: {
          Accept: 'text/html, application/json'
        }
      });

      const text = await response.text();
      let html = text;

      if (text.trim().startsWith('{')) {
        const json = JSON.parse(text);
        html = json[sectionId] || json['cart-drawer'] || '';
      }

      if (!html || !html.includes('id="cart-drawer"')) {
        continue;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;

      const newDrawer = temp.querySelector('#cart-drawer');
      const drawer = document.querySelector('#cart-drawer');

      if (!newDrawer || !drawer) continue;

      const wasOpen =
        drawer.hasAttribute('open') ||
        drawer.classList.contains('menu-opening') ||
        drawer.classList.contains('is-open') ||
        drawer.classList.contains('active');

      drawer.innerHTML = newDrawer.innerHTML;

      if (wasOpen) {
        drawer.removeAttribute('hidden');
        drawer.setAttribute('open', 'true');
        drawer.classList.add('menu-opening', 'open', 'is-open', 'active');
        document.body.classList.add('overflow-hidden');
      }

      await ibTagCartRows();
      ibLockAddonQuantityControls();

      return true;
    } catch (error) {
      console.warn('[IB] Refresh attempt failed:', url, error);
    }
  }

  console.warn('[IB] All cart drawer refresh methods failed');
  return false;
}

async function ibRefreshAfterCartChange() {
  ibSetCartLoading(true);

  try {
    if (ibIsCartPageMode()) {
      window.location.reload();
      return;
    }

    await ibRefreshCartDrawer();
    await ibTagCartRows();
    ibLockAddonQuantityControls();
  } finally {
    ibSetCartLoading(false);
  }
}

async function ibTagCartRows() {
  const cart = await ibFetchCart();

  document.querySelectorAll('.js-cart-item').forEach(row => {
    row.removeAttribute('data-ib-bundle-role');
    row.removeAttribute('data-ib-bundle-id');
    row.removeAttribute('data-ib-parent-variant-id');
  });

  cart.items.forEach(item => {
    const escapedKey = ibSafeCssEscape(item.key);
    const row = document.querySelector(`.js-cart-item[data-key="${escapedKey}"]`);

    if (!row || !item.properties) return;

    const bundleId = item.properties._ib_bundle_id;
    const bundleRole = item.properties._ib_bundle_role;
    const parentVariantId = item.properties._ib_parent_variant_id;

    if (bundleId && bundleRole) {
      row.setAttribute('data-ib-bundle-id', bundleId);
      row.setAttribute('data-ib-bundle-role', bundleRole);

      if (parentVariantId) {
        row.setAttribute('data-ib-parent-variant-id', parentVariantId);
      }
    }
  });
}

/* =========================
   Bundle sync logic
========================= */

async function ibSyncBundles(shouldRefreshDrawer = true) {
  if (ibCartLineChanging) return;

  ibCartLineChanging = true;
  let cartChanged = false;

  try {
    const cart = await ibFetchCart();
    const bundles = {};

    cart.items.forEach(item => {
      const bundleId = item.properties && item.properties._ib_bundle_id;
      if (!bundleId) return;

      if (!bundles[bundleId]) {
        bundles[bundleId] = [];
      }

      bundles[bundleId].push(item);
    });

    const updates = [];

    Object.values(bundles).forEach(lines => {
      const base = lines.find(item => {
        return item.properties && item.properties._ib_bundle_role === 'base';
      });

      const addons = lines.filter(item => {
        return item.properties && item.properties._ib_bundle_role === 'addon';
      });

      if (!base) {
        addons.forEach(addon => {
          updates.push(ibChangeLine(addon.key, 0));
          cartChanged = true;
        });

        return;
      }

      addons.forEach(addon => {
        if (addon.quantity !== base.quantity) {
          updates.push(ibChangeLine(addon.key, base.quantity));
          cartChanged = true;
        }
      });
    });

    if (updates.length) {
      await Promise.all(updates);
    }

    if (shouldRefreshDrawer && cartChanged) {
      await ibRefreshAfterCartChange();
    } else {
      await ibTagCartRows();
      ibLockAddonQuantityControls();
    }
  } catch (error) {
    console.warn('[IB] Bundle sync failed:', error);
  } finally {
    ibCartLineChanging = false;
  }
}

/* =========================
   Lock addon quantity controls
========================= */

function ibLockAddonQuantityControls() {
  const addonRows = [...document.querySelectorAll('.js-cart-item')]
    .filter(row => ibIsAddonRow(row));

  addonRows.forEach(row => {
    row.classList.add('ib-addon-cart-line');

    const quantityContainer =
      row.querySelector('quantity-input') ||
      row.querySelector('.quantity-selector') ||
      row.querySelector('.quantity');

    if (quantityContainer) {
      quantityContainer.style.opacity = '.45';
      quantityContainer.style.pointerEvents = 'none';
    }

    row.querySelectorAll('input[name="updates[]"], .quantity-selector__input').forEach(input => {
      input.readOnly = true;
      input.setAttribute('aria-readonly', 'true');
      input.classList.add('ib-addon-quantity-disabled');
    });

    row.querySelectorAll('button[name="minus"], button[name="plus"], .quantity-selector__button').forEach(button => {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('ib-addon-quantity-disabled');
    });
  });
}

/* =========================
   Cart sync events
========================= */

function ibForceCloseCartDrawer() {
  if (!ibIsCartDrawerMode()) return;

  const drawer = document.querySelector('#cart-drawer');

  if (!drawer) return;

  drawer.removeAttribute('open');
  drawer.removeAttribute('aria-modal');
  drawer.removeAttribute('aria-hidden');
  drawer.setAttribute('hidden', '');

  drawer.classList.remove(
    'menu-opening',
    'open',
    'is-open',
    'active',
    'animate'
  );

  document.body.classList.remove(
    'overflow-hidden',
    'cart-drawer-open',
    'drawer-open',
    'menu-opening',
    'modal-open',
    'lock-scroll'
  );

  document.documentElement.classList.remove(
    'overflow-hidden',
    'cart-drawer-open',
    'drawer-open',
    'menu-opening',
    'modal-open',
    'lock-scroll'
  );

  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';

  document.activeElement?.blur?.();
}

async function ibChangeBundleQuantityFromBaseRow(baseRow, newQuantity) {
  if (!baseRow || ibCartLineChanging) return;

  const lineKey = baseRow.dataset.key;
  if (!lineKey) return;

  ibCartLineChanging = true;
  ibSetCartLoading(true);

  try {
    const { cart, item } = await ibGetCartItemByKey(lineKey);

    if (
      !item ||
      !item.properties ||
      item.properties._ib_bundle_role !== 'base'
    ) {
      return;
    }

    const bundleId = item.properties._ib_bundle_id;
    const bundleItems = ibGetBundleItems(cart, bundleId);

    const updates = {};

    bundleItems.forEach(bundleItem => {
      updates[bundleItem.key] = newQuantity;
    });

    const response = await ibUpdateLines(updates);

    if (!response.ok) {
      throw new Error('Bundle quantity update failed');
    }

    await ibRefreshAfterCartChange();
  } catch (error) {
    console.warn('[IB] Bundle quantity update failed:', error);
  } finally {
    ibSetCartLoading(false);
    ibCartLineChanging = false;
  }
}

function initIbCartSync() {
  if (window.IB_DISABLE_CART_LOGIC) {
    console.log('[IB] Cart sync disabled');
    return;
  }

  if (document.documentElement.dataset.ibCartSyncInitialized === 'true') {
    return;
  }

  document.documentElement.dataset.ibCartSyncInitialized = 'true';

  ibSyncBundles(false);
  ibLockAddonQuantityControls();

  document.addEventListener(
    'click',
    async event => {
      if (ibIsCartDrawerMode()) {
        const closeButton = event.target.closest(
          '[data-drawer-to-close="cart-drawer"], .drawer__close-button--left'
        );

        if (closeButton) {
          setTimeout(ibForceCloseCartDrawer, 50);
          setTimeout(ibForceCloseCartDrawer, 150);
          setTimeout(ibForceCloseCartDrawer, 300);
          return;
        }
      }

      const cartContainer = ibGetCartContainerFromEvent(event);
      if (!cartContainer) return;

      if (!ibCartHasBundleRows()) {
        await ibTagCartRows();
        ibLockAddonQuantityControls();

        if (!ibCartHasBundleRows()) return;
      }

      const row = event.target.closest('.js-cart-item');
      if (!row) return;

      if (!ibIsBundleRow(row)) return;

      const lineKey = row.dataset.key;
      if (!lineKey) return;

      const quantityButton = event.target.closest(
        'button[name="minus"], button[name="plus"], .quantity-selector__button, quantity-input button'
      );

      if (quantityButton && ibIsAddonRow(row)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        ibLockAddonQuantityControls();
        return false;
      }

      if (quantityButton && ibIsBaseRow(row)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const input = row.querySelector('input[name="updates[]"], .quantity-selector__input');
        const currentQuantity = Number(input && input.value ? input.value : 1);

        const direction =
          quantityButton.name === 'minus' ||
          quantityButton.getAttribute('name') === 'minus'
            ? -1
            : 1;

        const newQuantity = Math.max(0, currentQuantity + direction);

        if (input) {
          input.value = newQuantity;
        }

        await ibChangeBundleQuantityFromBaseRow(row, newQuantity);
        return false;
      }

      const removeButton = event.target.closest(
        'cart-remove-button, .cart-item__remove, .cart-item__remove a, a[href*="quantity=0"], a[href*="/cart/change"]'
      );

      if (!removeButton) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      ibSetCartLoading(true);

      try {
        const cart = await ibFetchCart();
        const currentItem = cart.items.find(item => item.key === lineKey);

        if (!currentItem) {
          await ibRefreshAfterCartChange();
          return false;
        }

        const currentRole =
          currentItem.properties && currentItem.properties._ib_bundle_role;

        const currentBundleId =
          currentItem.properties && currentItem.properties._ib_bundle_id;

        if (currentRole === 'base' && currentBundleId) {
          const updates = {};

          cart.items.forEach(item => {
            if (
              item.properties &&
              item.properties._ib_bundle_id === currentBundleId
            ) {
              updates[item.key] = 0;
            }
          });

          await ibUpdateLines(updates);
        } else {
          await ibChangeLine(lineKey, 0);
        }

        await ibRefreshAfterCartChange();
      } catch (error) {
        console.warn('[IB] Remove failed:', error);
      } finally {
        ibSetCartLoading(false);
      }

      return false;
    },
    true
  );

  document.addEventListener(
    'change',
    async event => {
      const input = event.target;

      if (
        !input.closest(IB_CART_CONTAINER_SELECTOR) ||
        !(
          input.matches('input[name="updates[]"]') ||
          input.matches('.quantity-selector__input')
        )
      ) {
        return;
      }

      if (!ibCartHasBundleRows()) {
        await ibTagCartRows();
        ibLockAddonQuantityControls();

        if (!ibCartHasBundleRows()) return;
      }

      const row = input.closest('.js-cart-item');

      // Non-bundle cart lines should never be blocked.
      // Subscriptions / memberships should stay controlled by the theme/app.
      if (!row) return;

      if (!ibIsBundleRow(row)) {
        return;
      }

      if (ibIsMembershipRow(row)) {
        return;
      }

      if (ibIsAddonRow(row)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        await ibRefreshAfterCartChange();
        return false;
      }

      if (ibIsBaseRow(row)) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const newQuantity = Math.max(0, Number(input.value || 0));
        await ibChangeBundleQuantityFromBaseRow(row, newQuantity);

        return false;
      }
    },
    true
  );

  document.addEventListener('cart-drawer:open', () => {
    if (!ibIsCartDrawerMode()) return;

    ibClearIbCartStateForNonBundleCart();

    if (!ibCartHasBundleRows()) return;

    ibTagCartRows().then(ibLockAddonQuantityControls);
  });
}

function ibClearIbCartStateForNonBundleCart() {
  if (!ibIsCartDrawerMode()) return;
  if (ibCartHasBundleRows()) return;

  const drawer = document.querySelector('#cart-drawer');
  if (!drawer) return;

  drawer.classList.remove('ib-cart-loading');

  drawer.querySelectorAll('.ib-addon-cart-line').forEach(row => {
    row.classList.remove('ib-addon-cart-line');
  });

  drawer.querySelectorAll('.ib-addon-quantity-disabled').forEach(el => {
    el.classList.remove('ib-addon-quantity-disabled');
    el.removeAttribute('aria-disabled');
    el.removeAttribute('aria-readonly');

    if ('readOnly' in el) {
      el.readOnly = false;
    }
  });

  drawer.querySelectorAll('quantity-input, .quantity-selector, .quantity').forEach(el => {
    el.style.opacity = '';
    el.style.pointerEvents = '';
  });
}